<script setup lang="ts">
import { KsCollapsibleContent } from '@aschehoug/kloss-2'
</script>

<template>
  <KsCollapsibleContent class="collapsible-content">
    <slot />
  </KsCollapsibleContent>
</template>

<style lang="scss" scoped>
  .collapsible-content {
    overflow: hidden;
  }

  .collapsible-content[data-state="open"] {
    animation: slide-down 250ms ease-out;
  }

  .collapsible-content[data-state="closed"] {
    animation: slide-up 250ms ease-out;
  }

  @keyframes slide-down {
    from {
      height: 0;
    }

    to {
      height: var(--reka-collapsible-content-height);
    }
  }

  @keyframes slide-up {
    from {
      height: var(--reka-collapsible-content-height);
    }

    to {
      height: 0;
    }
  }
</style>
